import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import classNames from 'classnames';
import { render, unmount } from 'rc-util/lib/React/render';
import React, { useEffect } from 'react';
import { ILoadingProps } from '../types/loading';
import './index.less';

type LoadingShowOptions = string | Pick<ILoadingProps, 'tip' | 'allowClickMask' | 'allowScroll'>;

interface LoadingComponent extends React.FC<ILoadingProps> {
    show: (options?: LoadingShowOptions) => void;
    hidden: () => void;
}

export const createLoading = () => {
    const Loading: LoadingComponent = (props) => {
        const { tip, allowClickMask = false, allowScroll = false, className, style } = props;

        useEffect(() => {
            if (allowScroll) {
                return;
            }

            disableBodyScroll(document.body, {
                reserveScrollBarGap: true,
            });
            return () => enableBodyScroll(document.body);
        }, [allowScroll]);

        return (
            <div
                className={classNames('xdesign-loading', className)}
                style={{ ...style, minWidth: tip ? 100 : 'auto' }}
            >
                {/* body禁止用户操作body */}
                {allowClickMask ? null : (
                    <style
                        dangerouslySetInnerHTML={{
                            __html: `html, body {
                          user-select: none;
                          pointer-events: none;
                      }`,
                        }}
                    />
                )}

                <div className="xdesign-loading__wrap">
                    <span className="xdesign-loading__content"></span>
                </div>

                {tip ? <div className="xdesign-loading__tip">{tip}</div> : null}
            </div>
        );
    };

    let el: HTMLDivElement | null = null;

    const show: LoadingComponent['show'] = (options) => {
        const tip = typeof options === 'string' ? options : options?.tip;
        const allowClickMask = typeof options === 'string' ? false : (options?.allowClickMask ?? false);
        const allowScroll = typeof options === 'string' ? false : (options?.allowScroll ?? false);

        if (!el) {
            el = document.createElement('div');
        }
        document.body.appendChild(el);
        render(<Loading tip={tip} allowClickMask={allowClickMask} allowScroll={allowScroll} />, el);
    };

    const hidden: LoadingComponent['hidden'] = () => {
        if (el && el.parentNode) {
            unmount(el);
            el.parentNode.removeChild(el);
            el = null;
        }
    };

    Loading.show = show;
    Loading.hidden = hidden;

    return Loading;
};

const Loading = createLoading();

export default Loading;
